<div
  class="customer-flags-list"
  *ngIf="(user$ | async) && (updatedFields$ | async) as updatedFields">
  <mat-card class="customer-flags-card">
    <mat-card-title> </mat-card-title>
    <mat-card-content>
      <div>
        <mat-checkbox
          [(ngModel)]="updatedFields.enablePoolerTypes"
          name="enablePoolerTypes"
          data-cy="customer-flags-enable-pooler-types">
          {{ "enablePoolerTypes" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="!(customer$ | async)?.enableJobRequestProcess">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableDemandReasons"
          name="enableDemandReasons"
          data-cy="customer-flags-enable-demand-reasons">
          {{ "enableDemandReasons" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.prioritizeEmployeeLastName"
          name="prioritizeEmployeeLastName"
          data-cy="customer-flags-prioritize-employee-last-name">
          {{ "prioritizeEmployeeLastName" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableCopyDateOnDuplicate"
          name="enableCopyDateOnDuplicate"
          data-cy="customer-flags-enable-copy-date-on-duplicate">
          {{ "enableCopyDateOnDuplicate" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="
            updatedFields.allowIgnoreUserPreferenceDepartmentBlacklist
          "
          name="allowIgnoreUserPreferenceDepartmentBlacklist"
          data-cy="customer-flags-allow-ignore-user-preference-department-blacklist">
          {{ "allowIgnoreUserPreferenceDepartmentBlacklist" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.preventChangingOfCreator"
          name="allowIgnoreUserPreferenceDepartmentBlacklist"
          data-cy="customer-flags-allow-ignore-user-preference-department-blacklist">
          {{ "preventChangingOfCreator" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.disableDispoFilterSave"
          name="disableDispoFilterSave"
          data-cy="customer-flags-disable-dispo-filter-save">
          {{ "disableDispoFilterSave" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableTranscribeJobList"
          name="enableTranscribeJobList"
          data-cy="customer-flags-enable-transcribe-job-list">
          <div class="checkbox-label">
            {{ "enableTranscribeJobList" | i18n }}
            <mat-icon
              svgIcon="info"
              class="info-icon"
              [matTooltip]="'enableTranscribeJobListDescription' | i18n"
              matTooltipHideDelay="1000"
              matTooltipPosition="above"></mat-icon>
          </div>
        </mat-checkbox>
      </div>
      <div
        *ngIf="(customer$ | async)?.customerType === customerTypeEnum.AGENCY">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.transferredJobsNoLongerActionRequired"
          name="transferredJobsNoLongerActionRequired"
          data-cy="customer-flags-transferred-jobs-no-longer-action-required">
          {{ "transferredJobsNoLongerActionRequired" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="(customer$ | async)?.enableJobRequestProcess">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.approvedJobRequestsNoLongerActionRequired"
          name="approvedJobRequestsNoLongerActionRequired"
          data-cy="customer-flags-approved-job-requests-no-longer-action-required">
          {{ "approvedJobRequestsNoLongerActionRequired" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="enableJobRequestProcess$ | async">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableJobRequestApproval"
          name="enableJobRequestApproval"
          data-cy="customer-flags-needs-job-request-approval">
          {{ "enableJobRequestApproval" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="enableJobRequestProcess$ | async">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableCaseNumberInJobRequests"
          name="enableCaseNumberInJobRequests"
          data-cy="customer-flags-enable-case-number-in-job-requests">
          {{ "enableCaseNumberInJobRequests" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="enableJobRequestProcess$ | async">
        <br />
        <mat-checkbox
          [ngModel]="updatedFields.requestersCanAccessReports"
          (ngModelChange)="updateRequestersCanAccessReports($event)"
          name="requestersCanAccessReports"
          data-cy="customer-flags-requesters-can-access-reports">
          {{ "requestersCanAccessReports" | i18n }}
        </mat-checkbox>
      </div>
      <div
        *ngIf="
          (enableJobRequestProcess$ | async) &&
          updatedFields.requestersCanAccessReports
        "
        style="padding-left: 24px">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.requestersCanAccessJobOverviewReport"
          name="requestersCanAccessJobOverviewReport"
          data-cy="customer-flags-requesters-can-access-job-overview-report">
          {{ "requestersCanAccessJobOverviewReport" | i18n }}
        </mat-checkbox>
      </div>
      <div
        *ngIf="(customer$ | async)?.customerType !== customerTypeEnum.HOSPITAL">
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableAutoDirectAccept"
          name="enableAutoDirectAccept"
          data-cy="customer-flags-enable-auto-book-invitees">
          {{ "enableAutoDirectAccept" | i18n }}
        </mat-checkbox>
      </div>
      <div
        *ngIf="
          updatedFields.enableAutoDirectAccept &&
          (preventAutoDirectAcceptWithinHours$
            | async) as preventAutoDirectAcceptWithinHours
        "
        class="auto-book-settings">
        <h3>
          {{ "preventAutoDirectAcceptWithinHours" | i18n }}
        </h3>
        <div class="shift-settings-container row">
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.0" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventAutoDirectAcceptWithinHours[shiftEnum.EARLY]
                "
                name="autoBookEarly"
                data-cy="auto-book-early-shift" />
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.1" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="preventAutoDirectAcceptWithinHours[shiftEnum.DAY]"
                name="autoBookDay"
                data-cy="auto-book-day-shift" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.2" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="preventAutoDirectAcceptWithinHours[shiftEnum.LATE]"
                name="autoBookLate"
                data-cy="auto-book-late-shift" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.3" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventAutoDirectAcceptWithinHours[shiftEnum.NIGHT]
                "
                name="autoBookNight"
                data-cy="auto-book-night-shift" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enableMonthlyHours"
          name="enableMonthlyHours"
          data-cy="customer-flags-enable-monthly-hours">
          {{ "enableMonthlyHours" | i18n }}
        </mat-checkbox>
      </div>
      <div>
        <br />
        <mat-checkbox
          [(ngModel)]="updatedFields.enablePerigonApi"
          name="enablePerigonApi"
          data-cy="customer-flags-enable-perigon-api">
          {{ "enablePerigonApi" | i18n }}
        </mat-checkbox>
      </div>
      <div *ngIf="updatedFields.perigonBearerToken">
        <br />
        <mat-form-field>
          <mat-label>{{ "perigonBearerToken" | i18n }}</mat-label>
          <input
            matInput
            [value]="updatedFields.perigonBearerToken"
            disabled
            name="perigonBearerToken"
            data-cy="customer-flags-perigon-bearer-token" />
        </mat-form-field>
      </div>
      <div
        *ngIf="
          preventDirectAcceptWithinHoursPerShift$
            | async as preventDirectAcceptWithinHoursPerShift
        "
        class="prevent-direct-accept-within-seconds-per-shift-settings">
        <h3>
          {{ "preventDirectAcceptWithinHoursPerShift" | i18n }}
        </h3>
        <div class="shift-settings-container row">
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.0" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventDirectAcceptWithinHoursPerShift[shiftEnum.EARLY]
                "
                name="preventDirectAcceptWithinSecondsPerShiftEarly"
                data-cy="prevent-direct-accept-within-seconds-per-shift-early-shift" />
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.1" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventDirectAcceptWithinHoursPerShift[shiftEnum.DAY]
                "
                name="preventDirectAcceptWithinSecondsPerShiftDay"
                data-cy="prevent-direct-accept-within-seconds-per-shift-day-shift" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.2" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventDirectAcceptWithinHoursPerShift[shiftEnum.LATE]
                "
                name="preventDirectAcceptWithinSecondsPerShiftLate"
                data-cy="prevent-direct-accept-within-seconds-per-shift-late-shift" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>{{ "shifts.3" | i18n }}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="
                  preventDirectAcceptWithinHoursPerShift[shiftEnum.NIGHT]
                "
                name="preventDirectAcceptWithinSecondsPerShiftNight"
                data-cy="prevent-direct-accept-within-seconds-per-shift-night-shift" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div>
        <br />
        <mat-form-field>
          <mat-label>{{ "requiredPause" | i18n }}</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="updatedFields.requiredPause"
            name="requiredPause"
            min="0"
            data-cy="customer-flags-required-pause" />
          <span
            matSuffix
            class="mat-form-field-suffix"
            >h</span
          >
        </mat-form-field>
      </div>
      <div>
        <br />
        <mat-form-field class="cancel-reason-availability-select">
          <mat-label>{{ "archiveAtType" | i18n }}</mat-label>
          <mat-select
            [(ngModel)]="updatedFields.archiveAtType"
            name="archiveAtType"
            data-cy="customer-flags-archive-at-type">
            <mat-option [value]="archiveAtTypeEnum.START_OF_JOB">{{
              "archiveAtTypeEnum.START_OF_JOB" | i18n
            }}</mat-option>
            <mat-option [value]="archiveAtTypeEnum.END_OF_JOB">{{
              "archiveAtTypeEnum.END_OF_JOB" | i18n
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-label>{{ "archiveAtOffset" | i18n }}</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="updatedFields.archiveAtOffset"
            (ngModelChange)="updateArchiveAtOffset()"
            name="archiveAtOffset"
            data-cy="customer-flags-archive-at-offset" />
          <span
            matSuffix
            class="mat-form-field-suffix"
            >min</span
          >
          <mat-hint
            *ngIf="
              updatedFields.archiveAtType === archiveAtTypeEnum.START_OF_JOB
            ">
            {{
              "archiveAtOffsetDescriptionStartOfJob"
                | i18n: { timeStamp: archiveOffsetDescriptionStartOfJob }
            }}
          </mat-hint>
          <mat-hint
            *ngIf="
              updatedFields.archiveAtType === archiveAtTypeEnum.END_OF_JOB
            ">
            {{
              "archiveAtOffsetDescriptionEndOfJob"
                | i18n: { timeStamp: archiveOffsetDescriptionEndOfJob }
            }}
          </mat-hint>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="customer-flags-card">
    <mat-card-title> {{ "timeTracking" | i18n }}</mat-card-title>
    <mat-card-content>
      <div>
        <mat-checkbox
          [(ngModel)]="updatedFields.timeTrackingEnabled"
          name="timeTrackingEnabled"
          data-cy="customer-flags-time-tracking-enabled"
          (click)="toggleTimeTrackingEnabled($event)">
          {{ "timeTrackingEnabled" | i18n }}
        </mat-checkbox>
      </div>
      <ng-container *ngIf="updatedFields.timeTrackingEnabled">
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.enableTimeTrackingSigninProcess"
            name="enableTimeTrackingSigninProcess"
            data-cy="customer-flags-enable-time-tracking-signin-process">
            {{ "enableTimeTrackingSigninProcess" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.timeTrackingDescriptionRequiredOnChange"
            name="timeTrackingDescriptionRequiredOnChange"
            data-cy="customer-flags-time-tracking-description-required-on-change">
            {{ "timeTrackingDescriptionRequiredOnChange" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.disableTimetrackingForOwnPoolers"
            name="disableTimetrackingForOwnPoolers"
            data-cy="customer-flags-disable-timetracking-for-own-poolers">
            {{ "disableTimetrackingForOwnPoolers" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [ngModel]="
              !updatedFields.disableTimetrackingForNewOrganisationsByDefault
            "
            (ngModelChange)="
              updateDisableTimetrackingForNewOrganisationsByDefault(!$event)
            "
            name="disableTimetrackingForNewOrganisationsByDefault"
            data-cy="customer-flags-enable-timetracking-for-new-organisations-by-default">
            {{ "disableTimetrackingForNewOrganisationsByDefault" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="
              updatedFields.disableApproveTimetrackingNotificationsForTransfers
            "
            name="disableApproveTimetrackingNotificationsForTransfers"
            data-cy="customer-flags-disable-approve-timetracking-notifications-for-transfers">
            {{ "disableApproveTimetrackingNotificationsForTransfers" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-form-field>
            <mat-label>{{ "timeTrackingAutoApproveInDays" | i18n }}</mat-label>
            <input
              matInput
              type="number"
              min="1"
              [(ngModel)]="updatedFields.timeTrackingAutoApproveInDays"
              name="timeTrackingAutoApproveInDays"
              data-cy="time-tracking-auto-approve-in-days" />
          </mat-form-field>
        </div>
        <div>
          <br />
          <mat-form-field>
            <mat-label>{{ "autoAddTimeTrackingHours" | i18n }}</mat-label>
            <input
              matInput
              type="number"
              min="1"
              [(ngModel)]="updatedFields.autoAddTimeTrackingHours"
              name="autoAddTimeTrackingHours"
              data-cy="auto-add-time-tracking-hours" />
          </mat-form-field>
        </div>
        <div
          class="time-tracking-default-pause-settings"
          *ngIf="
            timeTrackingDefaultPauseInHours$
              | async as timeTrackingDefaultPauseInHours
          ">
          <h3>
            {{ "timeTrackingDefaultPause" | i18n }}
          </h3>
          <div class="shift-settings-container row">
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>{{ "shifts.0" | i18n }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="timeTrackingDefaultPauseInHours[shiftEnum.EARLY]"
                  name="autoBookEarly"
                  max="10"
                  min="0"
                  data-cy="time-tracking-default-pause-early-shift" />
                <span
                  matSuffix
                  class="mat-form-field-suffix"
                  >h</span
                >
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>{{ "shifts.1" | i18n }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="timeTrackingDefaultPauseInHours[shiftEnum.DAY]"
                  name="autoBookDay"
                  max="10"
                  min="0"
                  data-cy="time-tracking-default-pause-day-shift" />
                <span
                  matSuffix
                  class="mat-form-field-suffix"
                  >h</span
                >
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>{{ "shifts.2" | i18n }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="timeTrackingDefaultPauseInHours[shiftEnum.LATE]"
                  name="autoBookLate"
                  max="10"
                  min="0"
                  data-cy="time-tracking-default-pause-late-shift" />
                <span
                  matSuffix
                  class="mat-form-field-suffix"
                  >h</span
                >
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>{{ "shifts.3" | i18n }}</mat-label>
                <input
                  matInput
                  type="number"
                  [(ngModel)]="timeTrackingDefaultPauseInHours[shiftEnum.NIGHT]"
                  name="autoBookNight"
                  max="10"
                  min="0"
                  data-cy="time-tracking-default-pause-night-shift" />
                <span
                  matSuffix
                  class="mat-form-field-suffix"
                  >h</span
                >
              </mat-form-field>
            </div>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
  <mat-card class="customer-flags-card">
    <mat-card-title> {{ "jobMatrix" | i18n }}</mat-card-title>
    <mat-card-content>
      <div>
        <mat-checkbox
          [(ngModel)]="updatedFields.enableRequestOverview"
          name="enableRequestOverview"
          data-cy="customer-flags-enable-job-matrix">
          {{ "enableRequestOverview" | i18n }}
        </mat-checkbox>
      </div>
      <ng-container *ngIf="updatedFields.enableRequestOverview">
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.jobMatrixForRequester"
            name="jobMatrixForRequester"
            data-cy="customer-flags-job-matrix-for-requester">
            {{ "jobMatrixForRequester" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.enableSectionToggleInJobMatrix"
            name="enableSectionToggleInJobMatrix"
            data-cy="customer-flags-enable-section-toggle-in-request-overview">
            {{ "enableSectionToggleInJobMatrix" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.jobMatrixHideCanceledJobs"
            name="jobMatrixHideCanceledJobs"
            data-cy="customer-flags-job-matrix-hide-canceled-jobs">
            {{ "jobMatrixHideCanceledJobs" | i18n }}
          </mat-checkbox>
        </div>
        <div *ngIf="updatedFields.jobMatrixHideCanceledJobs">
          <br />
          <mat-form-field *ngIf="cancelReasons$ | async as cancelReasons">
            <mat-label>{{ "exceptions" | i18n }}:</mat-label>
            <mat-select
              [ngModel]="selectedCancelReasonIds"
              (ngModelChange)="selectCancelReason($event, cancelReasons)"
              multiple
              data-cy="job-matrix-cancel-reason-exceptions-select">
              <mat-option
                *ngFor="let reasonOption of cancelReasons"
                [value]="reasonOption.id">
                <span
                  [attr.data-cy]="
                    'job-matrix-cancel-reason-exceptions-option-' +
                    reasonOption.id
                  ">
                  {{ reasonOption.displayName[locale] }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <p>
            {{ "jobMatrixCertificatePriority" | i18n }}
            <span class="hint">{{
              "jobMatrixCertificatePriorityDescription" | i18n
            }}</span>
          </p>
          <div
            class="row"
            *ngFor="
              let priority of updatedFields.jobMatrixCertificatePriority;
              let i = index
            ">
            <div class="col-2 col-md-1 priority-input">
              <button
                type="button"
                class="movement-chevron"
                [disabled]="i === 0"
                (click)="increaseCertificatePriority(i)">
                <mat-icon
                  svgIcon="chevron-down"
                  class="rotate"></mat-icon>
              </button>
              <span class="index-count"> {{ i + 1 }} </span>
              <button
                type="button"
                class="movement-chevron"
                [disabled]="
                  i ===
                  (updatedFields.jobMatrixCertificatePriority?.length ?? 0) - 1
                "
                (click)="decreaseCertificatePriority(i)">
                <mat-icon svgIcon="chevron-down"></mat-icon>
              </button>
            </div>
            <div class="col-10 col-md-11">
              <app-certificate-multiselect
                [allCertificates]="(customerCertificates$ | async) || []"
                [certificateGroups]="(certificateGroups$ | async) || []"
                [selectedMappedCertificates]="priority.certificates"
                (selectionChanged)="updateCertificatePriority(i, $event)"
                [hideAllOption]="true"></app-certificate-multiselect>
            </div>
          </div>
          <button
            class="outline-pill-button icon-left add-condition-group-button"
            type="button"
            (click)="addNewCertificatePriority()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{ "addCertificatePriority" | i18n }}
          </button>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
  <mat-card class="customer-flags-card">
    <mat-card-title> {{ "autoBookInviteesCardTitle" | i18n }}</mat-card-title>
    <mat-card-content>
      <br />
      <div>
        <mat-checkbox
          [(ngModel)]="updatedFields.autoBookInvitees"
          name="autoBookInvitees"
          data-cy="customer-flags-auto-book-invitees">
          {{ "autoBookInvitees" | i18n }}
        </mat-checkbox>
      </div>
      <ng-container *ngIf="updatedFields.autoBookInvitees">
        <div>
          <mat-slide-toggle
            [(ngModel)]="updatedFields.autoBookInviteesDepartmentDefault"
            name="autoBookInviteesDepartmentDefault"
            data-cy="customer-flags-auto-book-invitees-department-default">
            {{ "autoBookInviteesDepartmentDefault" | i18n }}
          </mat-slide-toggle>
        </div>
        <div>
          <br />
          <mat-checkbox
            [(ngModel)]="updatedFields.autoBookSelfSignIns"
            name="autoBookSelfSignIns"
            data-cy="customer-flags-disable-timetracking-for-own-poolers">
            {{ "autoBookSelfSignIns" | i18n }}
          </mat-checkbox>
        </div>
        <div>
          <mat-slide-toggle
            [(ngModel)]="updatedFields.autoBookSelfSignInsDepartmentDefault"
            [disabled]="!updatedFields.autoBookSelfSignIns"
            name="autoBookSelfSignInsDepartmentDefault"
            data-cy="customer-flags-auto-book-invitees-department-default">
            {{ "autoBookSelfSignInsDepartmentDefault" | i18n }}
          </mat-slide-toggle>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
<div class="floating-actions-bar">
  <button
    (click)="cancelChanges()"
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="cancel-assignments-customer-flags-button">
    <mat-icon svgIcon="close"></mat-icon>
    {{ "cancel" | i18n | titlecase }}
  </button>
  <button
    (click)="saveCustomerFlags()"
    class="primary-pill-button icon-left big-fab"
    type="button"
    data-cy="save-assignments-customer-flags-button">
    <mat-icon svgIcon="save"></mat-icon>
    {{ "save" | i18n | titlecase }}
  </button>
</div>
